import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(private httpClient: HttpClient) {
  }

  changePassword(oldPassword: string, newPassword: string): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/changePassword', {oldPassword, newPassword});
  }
}
